export const VESSEL_TYPES = ["Plate", "Header", "Vessel", "Freezer Assembly", "Misc."];
export const TEST_RESULTS = ["Pending", "Pass", "Fail", "Uncertain"];
export const TEST_MEDIA = ["Water", "Nitrogen"];
export const PRESSURE_PRESETS = ["35 bar", "75 bar"];

export const FAILURE_POINTS = [
  { code: "PTF1", label: "Front Bar (or Outlet side)" },
  { code: "PTF2", label: "Rear Bar (or Inlet side)" },
  { code: "PTF3", label: "Inlet Connector" },
  { code: "PTF4", label: "Outlet Connector" },
  { code: "PTF5", label: "Seam Weld" },
  { code: "PTF6", label: "Segmenting" },
  { code: "PTF7", label: "Welded Divider" },
  { code: "PTF8", label: "Material Failure" },
  { code: "PTF9", label: "Misc. (detail in notes)" },
];

// Coarse workflow status shown in the Status column: Pending → Tested → Complete.
// (Legacy "Passed"/"Failed"/"Blown Out" values are mapped at render time for old records.)
// Brand palette: Primary #39678F · Cream #E6E0DB · Slate #33424F · Sand #CCB795 · Sky #E6F3FF · Olive #50493B
// Accent: Green #6CC850 · Crimson #B30035
export const STATUS_COLORS = {
  Pending: {
    bg: "bg-[#f6efe2]",
    text: "text-[#50493b]",
    border: "border-[#ccb795]",
    dot: "bg-[#ccb795]",
  },
  Tested: {
    bg: "bg-[#e6f3ff]",
    text: "text-[#1e4166]",
    border: "border-[#39678f]",
    dot: "bg-[#39678f]",
  },
  Complete: {
    bg: "bg-[#33424f]",
    text: "text-white",
    border: "border-[#33424f]",
    dot: "bg-[#ccb795]",
  },
};
